export const URL_ROOT = '/';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDVZX5ei63HLdVVgGo2YvxpS7Mo1bwi7sQ",
  authDomain: "afterschool-music.firebaseapp.com",
  databaseURL: "https://afterschool-music-default-rtdb.firebaseio.com",
  projectId: "afterschool-music",
  storageBucket: "afterschool-music.appspot.com",
  messagingSenderId: "1086219217766",
  appId: "1:1086219217766:web:854d5a2b292e08cd8ab6a7",
  measurementId: "G-YZW1L9JCPZ"
};
